import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject,} from 'rxjs';
import { commonModal, ModalPopupSize } from '../model/common.model';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { RoutePath } from '../model/enum';

@Injectable({
  providedIn: 'root'
})
export class SendDataService {
  public sendCommonTabData = new BehaviorSubject<any>(undefined);
  private tablePagination = new BehaviorSubject<any>(undefined);
  private confirmationMessage = new BehaviorSubject<any>(undefined);
  private modalRefs: Map<string, NgbModalRef> = new Map();
  vendorListRefresh$ = new Subject<void>();
  popupIsOpen:boolean = false
  setDeletedMesage(data: any): void {
    this.confirmationMessage.next(data);
  }


  getDeletedMesage(): Observable<any> {
    return this.confirmationMessage.asObservable();
  }

  setPaginationData(data: any): void {
    this.tablePagination.next(data);
  }


  getPaginationData(): Observable<any> {
    return this.tablePagination.asObservable();
  }
  private _data: any;
  setAddressData(data: any) {
    this._data = data;
  }
  getAddressData(): any {
    return this._data;
  }
  private _contactData: any;
  setContactData(data: any) {
    this._contactData = data;
  }
  getContactData(): any {
    return this._contactData;
  }

  constructor(private modalService: NgbModal , public toaster?:ToastrService ,public router?: Router,public storageService?: StorageService,) { 
  }
  openModalPopup(component: any, data: any, title: string, popupSize: string = ModalPopupSize.LG, windowClass: string = "", fullscreen?: boolean, centered?: boolean): Promise<any> {
    commonModal.size = popupSize;
    commonModal.windowClass = windowClass;
    commonModal.centered = centered??true;

    const modalOption: NgbModalOptions = {
      ...commonModal,
    };
    const modalRef = this.modalService.open(component, modalOption);
    if (title != undefined)
      modalRef.componentInstance.title = title;
    modalRef.componentInstance.data = data;
    return modalRef.result.then(
      (result) => {
        if (result) {
          return result; // Returning the result back to the calling method
        }
      },
      (reason) => {
        // Handle dismissal case if needed
        return null;
      }
    );
  }
   borderDynamicHeight(isExapnded) {
    let dynamicHeight = this.getHeightStyle(isExapnded);
    let newHeight = dynamicHeight?.height;
    const match = newHeight.match(/\d+/);
    if (newHeight?.includes('calc')) {
      return { height: `calc(${newHeight.match(/\((.*)\)/)?.[1]} + 80px)` };
    }
    if (match) {
      return { height: `${parseInt(match[0], 10) + 80}px` };
    }
  
    return { height: newHeight }; 
  }

  getHeightStyle(isExapnded: boolean ,changeHeight:boolean = false,reduceHeight: number = 140): { height: string } {
   let headerHeights = localStorage.getItem('showSecondary') === 'true';
    let flexHeight = ''
    if(this.router?.url?.includes(RoutePath.VPLINFO_ROUTEPATH) || this.router?.url?.includes(RoutePath.OEMMANAGERINFO_ROUTEPATH)){
      let res = headerHeights ? 36 : 0;
      flexHeight = !isExapnded
        ? `calc(100vh - 415px - ${res}px)`
        : `calc(100vh - 560px - ${res}px)`;
      return {
        height: flexHeight,
      };
    }else if(this.router?.url == RoutePath.REQUIREMENT_ROUTEPATH || this.router?.url?.includes(RoutePath.REQUIREMENTINFO_ROUTEPATH)){
      let res = headerHeights ? 36 : 0;
      if(window.innerWidth < 1200)
     flexHeight = isExapnded ? `calc(100vh - 60rem - ${res}px)`: `calc(100vh - 38rem - ${res}px)`;
      else
      flexHeight = isExapnded ? `calc(100vh - 46rem - ${res}px)`: `calc(100vh - 24rem - ${res}px)`;
      return { height: flexHeight}
    }else{
    if (isExapnded && this.router?.url !== '/partInventory/parts-list') {
      let res = headerHeights ? 36 : 0;
      if(window?.innerWidth == 1024)
        flexHeight = changeHeight
      ? `calc(100vh - 920px - ${res}px)`
      : `calc(100vh - 970px - ${res}px)`;
     else  
    flexHeight = changeHeight
        ? `calc(100vh - (585px - ${res}px))`
        : `calc(100vh - (576px - ${res}px))`;
      return {
        height: flexHeight,
      };
    } else {
      if (this.router?.url === '/partInventory/parts-list') {
        return {
          height: this.calculateDynamicHeight(headerHeights,changeHeight,reduceHeight),
        };
      } else {
        let res = headerHeights ? 36 : 0;
       if(window.innerWidth <= 1024){
          flexHeight = changeHeight
          ? `calc(100vh - 550px - ${res}px)`
          : `calc(100vh - 550px - ${res}px)`;
        }else{
          flexHeight = changeHeight
          ? `calc(100vh - 367px - ${res}px)`
          : `calc(100vh - 385px - ${res}px)`;
        }
        return {
          height: flexHeight,
        };
      }
    }
  }
  }
  calculateDynamicHeight(headerHeights,changeHeight,reduceHeight): string {
    let height =  this.storageService?.retrieve('height')
    height =  height - reduceHeight
    let offset = headerHeights ? height: height;
    const screenWidth = window?.innerWidth;
    switch (true) {
      case screenWidth > 768 && screenWidth < 1024:
        offset = height - 100; 
        break;
  
      case screenWidth === 1024:
        height = height - 80;
        offset = headerHeights ? height : height;
        break;
      case screenWidth === 768:
        const res = headerHeights ? 25 : 0;
        offset = 190 - res;
        break;
    }
    return `${offset}px`;
    }
    
    calculateBorderDynamicHeight( offset: number = 65): number {
      let height =  this.storageService?.retrieve('height')
      return height - offset;
    }
closeModal(component: any): void {
  const modalId = component.name;
  if (this.modalRefs.has(modalId)) {
    this.modalRefs.get(modalId)?.close();
    this.modalRefs.delete(modalId);
  }
}
}
